import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import FieldWrapper from './FieldWrapper';
import TextFieldComp from './TextFieldComp';

const TextField = ({
  disabled,
  doubleAsterisk,
  fullWidth,
  hideLabel,
  hideRequiredAsterisk,
  hideTooltip,
  id,
  inputProps,
  label,
  placeholder,
  name,
  normalize,
  maxLength,
  multiline,
  noWrapper,
  readOnly,
  required,
  rows,
  rowsMax,
  style,
  type,
  highlightMissing,
  childrenSizeSM,
  showLabelChip,
  labelChipNotes,
  labelPlacement,
}) => {
  const Component = (
    <Field
      // Redux Form props
      component={TextFieldComp}
      normalize={normalize}
      // Custom props
      fullWidth={fullWidth}
      disabled={disabled}
      hideTooltip={hideTooltip}
      id={id}
      inputProps={inputProps}
      placeholder={placeholder || label}
      maxLength={maxLength}
      multiline={multiline}
      name={name}
      readOnly={readOnly}
      required={required}
      rows={rows}
      rowsMax={rowsMax}
      style={style}
      type={type}
      highlightMissing={highlightMissing}
    />
  );
  if (noWrapper) {
    return Component;
  }
  // Field with wrapper container
  return (
    <FieldWrapper
      doubleAsterisk={doubleAsterisk}
      hideRequiredAsterisk={hideRequiredAsterisk}
      label={!hideLabel ? label : null}
      labelPlacement={labelPlacement}
      required={required}
      sm={childrenSizeSM}
      showLabelChip={showLabelChip}
      labelChipNotes={labelChipNotes}
    >
      {Component}
    </FieldWrapper>
  );
};

TextField.propTypes = {
  disabled: PropTypes.bool,
  doubleAsterisk: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideLabel: PropTypes.bool,
  hideRequiredAsterisk: PropTypes.bool,
  hideTooltip: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inputProps: PropTypes.object,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  multiline: PropTypes.bool,
  name: PropTypes.string.isRequired,
  noWrapper: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  type: PropTypes.string,
  normalize: PropTypes.func,
  style: PropTypes.object,
  highlightMissing: PropTypes.bool,
  childrenSizeSM: PropTypes.number,
  labelPlacement: PropTypes.oneOf(['top', 'side']),
  showLabelChip: PropTypes.bool,
  labelChipNotes: PropTypes.arrayOf(PropTypes.node),
};

TextField.defaultProps = {
  disabled: false,
  doubleAsterisk: false,
  fullWidth: false,
  hideLabel: false,
  hideRequiredAsterisk: false,
  multiline: false,
  noWrapper: false,
  readOnly: false,
  required: false,
  rows: 0,
  rowsMax: 0,
  style: {},
  childrenSizeSM: 9,
  showLabelChip: false,
  labelChipNotes: [],
};

export default TextField;
